import type { LotType } from 'api/search/types';
import { LoadType } from 'types/cargosApp/Load';

type RateField = 'price' | 'priceNds' | 'priceNoNds';

export const sumRates = (lot: LotType, type: RateField) => {
  return lot.cargos.reduce((acc: number, current: LoadType) => {
    if (current.rate) return acc + (current.rate[type] || 0);

    return acc;
  }, 0);
};

export const sumRatesWithVat = (lot: LotType) => {
  const byPercent = new Map<number | undefined, number>();

  lot.cargos.forEach(cargo => {
    cargo.rate?.ratesWithVat?.forEach(({ rateWithVat, vatPercent }) => {
      if (!rateWithVat) return;
      byPercent.set(vatPercent, (byPercent.get(vatPercent) ?? 0) + rateWithVat);
    });
  });

  return [...byPercent.entries()]
    .map(([vatPercent, rateWithVat]) => ({ vatPercent, rateWithVat }))
    .filter(({ rateWithVat }) => rateWithVat > 0)
    .sort((a, b) => (b.vatPercent ?? 0) - (a.vatPercent ?? 0));
};
